import Vue from 'vue'

export var eventBus = new Vue()



// WEBPACK FOOTER //
// ./src/utils/event-bus.js